import {
  type Column,
  DownloadButton,
} from '@ovComponents/3-pattern/downloadButton/downloadButton';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export const FETCH_MODEL_PORTFOLIO_CHILDREN = `query fetchModelPortfolioChildren($input: FetchModelPortfolioChildrenInput!) {
  fetchModelPortfolioChildren(input: $input) {
    children {
      id
      percentage
      financialProduct {
        id
        name
        isCash
        ticker
        primaryAssetClass {
          id
          name
        }
        taxRank
        secondaryAssetClass {
          id
          name
        }
      }
      taxRank
      isCashEquivalent
    }
    totalCount
  }
}`;

type DownloadModelPortfolioSecuritiesProps = {
  modelPortfolioId: string;
  onDownloadComplete?: () => void;
  onExportStart?: () => void;
};

const DownloadModelPortfolioSecurities = ({
  modelPortfolioId,
  onDownloadComplete,
  onExportStart,
}: DownloadModelPortfolioSecuritiesProps) => {
  const { t } = useTranslation(['modelPortfolios', 'buildModels']);

  const columns: Column[] = [
    { gqlAlias: 'id', header: t('modelPortfolios:exportHeaders.securityId') },
    { gqlAlias: 'percentage', header: t('buildModels:percentage') },
    { gqlAlias: 'taxRank', header: t('buildModels:taxRank') },
    {
      gqlAlias: 'isCashEquivalent',
      header: t('modelPortfolios:exportHeaders.isCashEquivalent'),
    },
    {
      gqlAlias: 'financialProduct.id',
      header: t('modelPortfolios:exportHeaders.financialProductId'),
    },
    {
      gqlAlias: 'financialProduct.ticker',
      header: t('modelPortfolios:exportHeaders.financialProductTicker'),
    },
    {
      gqlAlias: 'financialProduct.name',
      header: t('modelPortfolios:exportHeaders.financialProductName'),
    },
    {
      gqlAlias: 'financialProduct.isCash',
      header: t('modelPortfolios:exportHeaders.financialProductIsCash'),
    },
    {
      gqlAlias: 'financialProduct.taxRank',
      header: t('modelPortfolios:exportHeaders.financialProductTaxRank'),
    },
    {
      gqlAlias: 'financialProduct.primaryAssetClass.id',
      header: t('modelPortfolios:exportHeaders.primaryAssetClassId'),
    },
    {
      gqlAlias: 'financialProduct.secondaryAssetClass.id',
      header: t('modelPortfolios:exportHeaders.secondaryAssetClassId'),
    },
  ];

  return (
    <DownloadButton
      configurable
      gql={FETCH_MODEL_PORTFOLIO_CHILDREN}
      fileName={`model_portfolio_securities_${dayjs().format('YYYY-MM-DD')}`}
      filter={{
        modelPortfolioId,
      }}
      columns={columns}
      queryPath='fetchModelPortfolioChildren'
      sortField='taxRank'
      sortDesc={false}
      datasetPath='children'
      progressTitle={t('modelPortfolios:exportConfig.progressTitle')}
      onExportComplete={onDownloadComplete}
      onExportStart={onExportStart}
    />
  );
};

export default DownloadModelPortfolioSecurities;
